import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConstants } from 'src/app/app.constants';
import { FormService } from 'src/app/services/form.service';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-recuperarcontraseniamodal',
  templateUrl: './recuperarcontraseniamodal.component.html',
  styleUrls: ['./recuperarcontraseniamodal.component.css']
})
export class RecuperarcontraseniamodalComponent implements OnInit {

  form: FormGroup;
  submitted: Boolean = false;
  sesion: any;
  showOldPassword: Boolean = false;
  showNewPassword: Boolean = false;
  showConfirmPassword: Boolean = false;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private usuarioService: UsuarioService,
    private alertService: NotificacionesService, private modalService: ModalService, private utils: UtilsService) { }

  ngOnInit(): void {
    this.form = this.formService.getRecuperarContraseniaModalForm();
  }

  accept() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modalService.mostrarModalCargando();
    this.usuarioService.recuperarContrasena(this.form.value.correoElectronico).subscribe((data: any) => {
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alertService.success(data.mensaje, true);
        this.close();
      } else {
        this.alertService.error(data.mensaje, true);
      }
      this.modalService.cerrarModalCargando();
    }, (error: any) => {
      console.error('Error', error);
      this.alertService.error('No se pudo recuperar su contraseña, intente de nuevo.', true);
      this.modalService.cerrarModalCargando();
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

}
